import { isAxiosError } from "axios";

export function isIncompletePatientPortalAccountError(error: unknown) {
    const INCOMPLETE_ACCOUNT_MESSAGES = [
        "no client practices",
        "no associated practices",
    ];

    if (isAxiosError(error) && error?.response?.data?.message) {
        const errorMessage = error.response.data.message.toLowerCase();
        return INCOMPLETE_ACCOUNT_MESSAGES.some((knownMessage) =>
            errorMessage.includes(knownMessage)
        );
    }

    if (error instanceof Error) {
        const errorMessage = error.message?.toLowerCase();
        return INCOMPLETE_ACCOUNT_MESSAGES.some((knownMessage) =>
            errorMessage.includes(knownMessage)
        );
    }

    return false;
}
